import React from "react";

export const Title = ({ props }) => {
  const title = props?.title ?? "";
  return (
    <section className="mt-10 mb-6 w-full">
      <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-gray-900 uppercase">
        {title}
      </h2>
      {/* Accent underline */}
      <div className="mt-3 h-[3px] w-16 rounded-full bg-gradient-to-r from-emerald-500 via-amber-500 to-purple-500" />
      <div className="mt-4 h-px w-full bg-gray-100" />
    </section>
  );
};

export const SubTitle = ({ props }) => {
  const title = props?.title ?? "";
  return (
    <div className="my-5 w-full text-center">
      <h3 className="inline-flex items-center justify-center rounded-xl bg-white px-4 py-2 text-sm sm:text-base font-semibold tracking-wide text-gray-800 uppercase shadow-sm">
        {title}
      </h3>
    </div>
  );
};
